export const AlertType = Object.freeze({
    SUCCESSES: 'success'
})